import { motion } from "framer-motion";
import areamaker from "../assets/areamaker.jpg";
import mindfulai from "../assets/mindfulai.png";
import career from "../assets/career.jpg";

export default function Projects() {
  const projects = [
    {
      image: areamaker,
      title: "Area Maker",
      description:
        "AI-powered tool that automates and optimizes floor plan generation with real-time customization.",
      link: "https://areamaker.com",
      live: true,
    },
    {
      image: mindfulai,
      title: "MindFulAI",
      description:
        "Modern and responsive company website for MindFulAI to showcase services and engage users.",
      link: "https://mindfulai.co.in",
      live: true,
    },
    {
      image: career,
      title: "Career Ascent",
      description:
        "Streamlined platform using GenAI for faculty appraisal automation and academic activity tracking.",
      link: "https://mindfulai.co.in",
      live: false,
    },
  ];

  return (
    <section
      id="projects"
      className="relative w-full bg-gradient-to-b from-black via-gray-950 to-black text-white px-6 md:px-12 lg:px-20 xl:px-28 py-24"
    >
      {/* Title Section */}
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-4xl mx-auto"
      >
        <h2 className="text-4xl sm:text-5xl font-extrabold text-blue-400 mb-4">
          Where Code Meets Creativity
        </h2>
        <p className="text-base sm:text-lg text-gray-300">
          Blending technology and design to deliver innovative, user-centric solutions.
        </p>
      </motion.div>

      {/* Projects Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-10 mt-16 place-items-center">
        {projects.map((project, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            whileHover={{
              scale: 1.03,
              rotateX: -4,
              rotateY: 4,
              transition: { type: "spring", stiffness: 200 },
            }}
            viewport={{ once: true }}
            className="w-full max-w-sm rounded-xl overflow-hidden shadow-2xl border border-gray-800 bg-gray-900 hover:shadow-blue-500/20 transition-all duration-300"
          >
            <div className="relative">
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-60 object-cover transition-transform duration-500"
                onContextMenu={(e) => e.preventDefault()}
                draggable="false"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-70"></div>
            </div>
            <div className="p-5">
              <h3 className="text-2xl font-semibold text-white">{project.title}</h3>
              <p className="text-gray-400 text-sm mt-2">{project.description}</p>

              {project.live ? (
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block mt-4 px-5 py-2 text-sm font-medium bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-cyan-500 hover:to-blue-600 text-whitetransition-all duration-200 shadow-lg rounded-full "
                >
                  Live Demo
                </a>
              ) : (
                <span className="inline-block mt-4 px-5 py-2 text-sm font-medium bg-gray-600 text-gray-400 rounded-full cursor-not-allowed">
                  Under Maintenance
                </span>
              )}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
